export default __webpack_public_path__ + "static/media/Info.5df2a27a.png";